import React from 'react';
import i18next from 'i18next';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { number, string } from 'prop-types';

import NumberInput from '~components/NumberInput';

import { TIME_MODIFIER_VARIANTS, VARIANTS } from './constants';
import useTimeModifier from './useTimeModifier';
import styles from './styles.module.scss';

function TimeModifier({ deliveryWaitTime, pickUpWaitTime, variant }) {
  const { waitTime, onWaitTimeChange } = useTimeModifier({
    deliveryWaitTime,
    pickUpWaitTime
  });

  return (
    <Stack className={styles[`container${variant}`]} {...VARIANTS[variant].containerProps}>
      {VARIANTS[variant].showIcon && <AccessTimeFilledIcon sx={{ color: 'grey.600' }} />}
      {VARIANTS[variant].fields.map(({ name, props, label, labelVariant, labelColor, classNames }) => (
        <div key={name} className={styles[classNames.container]}>
          <Typography variant={labelVariant} color={labelColor}>
            {i18next.t(label)}
          </Typography>
          <NumberInput
            name={name}
            onChange={onWaitTimeChange}
            value={waitTime[name]}
            className={styles[classNames.input]}
            variant={variant}
            {...props}
          />
        </div>
      ))}
    </Stack>
  );
}

TimeModifier.defaultProps = {
  variant: TIME_MODIFIER_VARIANTS.square
};

TimeModifier.propTypes = {
  deliveryWaitTime: number.isRequired,
  pickUpWaitTime: number.isRequired,
  variant: string
};

export default TimeModifier;
